<template>
  <div>

    <a  @click="fnShowModal()" class="p-2"><i class="far fa-edit text-primary"></i></a>

    <b-modal ref="modal" hide-footer title="Transmission">
        <div class="d-block">
          <form>

            <div class="form-group">
              <label for="transmission">Code</label>
              <input type="text" 
              class="form-control" 
              id="transmission" 
              placeholder="Transmission"
              v-model="transmission">
              <div class="invalid-feedback" v-if="errors.transmission">{{ errors.transmission[0] }}</div>
            </div>
           <b-form-checkbox
                id="checkbox-1"
                v-model="status"
                name="checkbox-1"
                value="1"
                unchecked-value="0"
                >
                Status
            </b-form-checkbox>
          <hr>
          <div class="text-right">
            <button type="button" class="btn btn-secondary btn-sm mr-2" @click="hideModal">Cancel</button>
            <button  type="button" @click="fnUpdate()" class="btn btn-success btn-sm">Update</button>
          </div>
          </form>
        </div>
      </b-modal>
  </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import * as messageService from '../../services/message.service';
    import * as transmissionService from '../../services/transmission.service';
    export default {
        name:"ModelTransmissionEdit",
        props:['propsData'],
        components: {
            
        },
        data(){
            return{
                errors:{},
                id:'',
                transmission:'',
                status:'',
            }
        },
        computed:{
            ...mapGetters(['gettTransmissionAll']),
        },
        methods:{
            ...mapActions(['fetchTransmissionAll']),
            fnShowModal(){
                this.fnGetValue(this.propsData)
                this.showModal();
            },
            hideModal(){
                this.$refs.modal.hide();
            },
            showModal(){
                this.$refs.modal.show();
            },

            fnGetValue(props){
                this.id = props.rowData.id;
                this.status = props.rowData.status;
                this.transmission = props.rowData.transmission;
            },

            fnUpdate:async function(){
                const obj = {
                    "transmission":this.transmission,
                    "status":this.status
                }

                try{
                    await transmissionService.update(this.id, obj);
                    this.fetchTransmissionAll();
                    messageService.fnSweetAlertSuccessToast('Transmission', 'Updated successfully ');
                    this.hideModal();

                    this.id = ''; 
                    this.transmission = '';
                    this.description = '';
                    this.status ='';
                }catch(error){
                    messageService.fnSweetAlertErrorToast('Transmission - update', error.response.data.message);
                }
            }
        }
    }
</script>